export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";